import type { ITableHeader } from '@/interfaces/ITableHeader'
import { useAppStore } from '@/stores/ui/AppStore'
import { type Composer } from 'vue-i18n'

export const getTableHeaders = (
  i18n: Composer<{}, {}, {}, string, never, string>
): Array<ITableHeader> => {
  const appStore = useAppStore()
  return [
    {
      title: i18n.t('fields.admins.lastName'),
      key: 'lastName',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.admins.firstName'),
      key: 'firstName',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.admins.email'),
      key: 'email',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.admins.role'),
      key: 'role',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: false }
    },
    {
      title: i18n.t('fields.admins.lastUpdated'),
      key: 'lastUpdated',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: false }
    },
    {
      title: i18n.t('fields.actions'),
      key: 'actions',
      align: 'start',
      nowrap: true,
      sortable: false,
      headerProps: { hidden: !appStore.isProgramAdmin }
    }
  ]
}
